export default "__VITE_ASSET__DuQJBhL1__"